export default __webpack_public_path__ + "static/media/school-background.cb673278.png";